import React from 'react';
import { Box, Button, Card, CardBody, CardTitle, FileInput, Flex, Form, FormField, Image, Textarea } from '../ui';

interface RecipeRealizationFormProps {
  recipeId: string;
  hasCurrentRealization: boolean;
  commentDraft: string;
  displayedImageUrl: string | null;
  submitting: boolean;
  fileInputRef: React.RefObject<HTMLInputElement | null>;
  onCommentDraftChange: (comment: string) => void;
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveImage: (input: HTMLInputElement | null) => void;
  onSubmit: (event: React.FormEvent) => Promise<void>;
  onDelete: () => void;
  onCancel: () => void;
}

const RecipeRealizationForm: React.FC<RecipeRealizationFormProps> = ({
  recipeId,
  hasCurrentRealization,
  commentDraft,
  displayedImageUrl,
  submitting,
  fileInputRef,
  onCommentDraftChange,
  onFileChange,
  onRemoveImage,
  onSubmit,
  onDelete,
  onCancel,
}) => (
  <Card shadow="sm" borderless marginBottom={4}>
    <CardBody>
      <CardTitle marginBottom={3}>
        {hasCurrentRealization ? 'Modifier ma realisation' : 'Partager ma realisation'}
      </CardTitle>
      <Form onSubmit={onSubmit}>
        <FormField label="Commentaire" htmlFor={`recipe-realization-comment-${recipeId}`}>
          <Textarea
            id={`recipe-realization-comment-${recipeId}`}
            rows={4}
            value={commentDraft}
            onChange={(event) => onCommentDraftChange(event.target.value)}
            placeholder="Explique ce que tu as prepare, les ajustements ou le resultat."
          />
        </FormField>

        <FormField label="Photo" htmlFor={`recipe-realization-file-${recipeId}`}>
          <FileInput
            id={`recipe-realization-file-${recipeId}`}
            ref={fileInputRef}
            accept="image/*"
            onChange={onFileChange}
          />
        </FormField>

        {displayedImageUrl && (
          <Box marginBottom={3}>
            <Image
              src={displayedImageUrl}
              alt="Apercu de la realisation"
              fluid
              rounded
              shadow="sm"
              maxHeight="260px"
              objectFit="cover"
            />
            <Box marginTop={2}>
              <Button
                type="button"
                size="sm"
                variant="secondary"
                outline
                onClick={() => onRemoveImage(fileInputRef.current)}
                disabled={submitting}
              >
                Retirer la photo
              </Button>
            </Box>
          </Box>
        )}

        <Flex gap={2} wrap>
          <Button type="submit" variant="primary" disabled={submitting}>
            {submitting
              ? 'Sauvegarde...'
              : hasCurrentRealization
                ? 'Mettre a jour ma realisation'
                : 'Publier ma realisation'}
          </Button>
          {hasCurrentRealization && (
            <Button
              type="button"
              variant="danger"
              outline
              onClick={onDelete}
              disabled={submitting}
            >
              Supprimer ma realisation
            </Button>
          )}
          <Button
            type="button"
            variant="secondary"
            outline
            onClick={onCancel}
            disabled={submitting}
          >
            Annuler
          </Button>
        </Flex>
      </Form>
    </CardBody>
  </Card>
);

export default RecipeRealizationForm;
